import React from 'react'
import propTypes from 'prop-types'
import { Grid } from '@material-ui/core'

import ValidatedTextField from '../../common/hooksForms/ValidatedTextField'

/**
 * A value made only of whitespace is treated as absent, so a field cannot be satisfied by pressing
 * the space bar. Codes are otherwise sent as captured — dropping leading zeros belongs to the
 * server, which is where uniqueness is enforced.
 */
export const requiredRule = (message) => ({
	required: message,
	validate: (value) => (value && String(value).trim().length > 0 ? true : message)
})

export const FIELD_RULES = {
	ObsoleteMaterialCode: requiredRule('Discontinued material code is required'),
	ObsoleteMaterialDescription: requiredRule('Discontinued material description is required'),
	SubstituteMaterialCode: requiredRule('Substitute material code is required'),
	SubstituteMaterialDescription: requiredRule('Substitute material description is required')
}

/**
 * Capture form for one substitute material relation.
 *
 * Shared by the add and the edit panels rather than duplicated: the requirement is that editing
 * applies the same validations as adding, and sharing the component makes that true by
 * construction instead of by discipline. The two panels differ only in their initial values and in
 * the action they dispatch.
 */
const SubstituteMaterialForm = (props) => {
	const { control, errors, initialValues } = props
	const valueOf = (name) => (initialValues && initialValues[name] ? initialValues[name] : '')

	return (
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<ValidatedTextField
					name='ObsoleteMaterialCode'
					label='Discontinued material code'
					autoFocus
					margin='dense'
					control={control}
					errors={errors}
					rules={FIELD_RULES.ObsoleteMaterialCode}
					defaultValue={valueOf('ObsoleteMaterialCode')}
				/>
			</Grid>
			<Grid item xs={12}>
				<ValidatedTextField
					name='ObsoleteMaterialDescription'
					label='Discontinued material description'
					margin='dense'
					control={control}
					errors={errors}
					rules={FIELD_RULES.ObsoleteMaterialDescription}
					defaultValue={valueOf('ObsoleteMaterialDescription')}
				/>
			</Grid>
			<Grid item xs={12}>
				<ValidatedTextField
					name='SubstituteMaterialCode'
					label='Substitute material code'
					margin='dense'
					control={control}
					errors={errors}
					rules={FIELD_RULES.SubstituteMaterialCode}
					defaultValue={valueOf('SubstituteMaterialCode')}
				/>
			</Grid>
			<Grid item xs={12}>
				<ValidatedTextField
					name='SubstituteMaterialDescription'
					label='Substitute material description'
					margin='dense'
					control={control}
					errors={errors}
					rules={FIELD_RULES.SubstituteMaterialDescription}
					defaultValue={valueOf('SubstituteMaterialDescription')}
				/>
			</Grid>
		</Grid>
	)
}

SubstituteMaterialForm.propTypes = {
	/**react-hook-form control object */
	control: propTypes.object.isRequired,
	/**react-hook-form errors object */
	errors: propTypes.object,
	/**Values to preload, used by the edit flow */
	initialValues: propTypes.object
}

SubstituteMaterialForm.defaultProps = {
	errors: {},
	initialValues: null
}

export default SubstituteMaterialForm
